import api from './base.api';
import type {
  DefineFragmentRequest,
  DefineFragmentResponse,
  FragmentDetail,
  ListFragmentsResponse,
} from '@/interfaces/fragments.interface';

/** Centralized MCP fragments base path (under apiBaseUrl, e.g. /api/v1). */
export const FRAGMENTS_BASE_PATH = '/mcp/projects';

const fragmentsPath = (projectId: string, suffix = '') =>
  `${FRAGMENTS_BASE_PATH}/${encodeURIComponent(projectId)}/fragments${suffix}`;

/**
 * Register (or overwrite) a durable run_pipelines fragment for a project so the
 * LLM agent can reuse it by name. Fails (400) on a name clash, unknown op, or
 * undeclared `$param` — the ValueError message is surfaced by the interceptor.
 */
export const defineFragment = async (
  projectId: string,
  body: DefineFragmentRequest,
): Promise<DefineFragmentResponse> => {
  const response = await api.post<DefineFragmentResponse>(
    fragmentsPath(projectId),
    body,
  );
  return response.data;
};

export const listFragments = async (
  projectId: string,
): Promise<ListFragmentsResponse> => {
  const response = await api.get<ListFragmentsResponse>(
    fragmentsPath(projectId),
  );
  return response.data;
};

export const getFragment = async (
  projectId: string,
  name: string,
): Promise<FragmentDetail> => {
  const response = await api.get<FragmentDetail>(
    fragmentsPath(projectId, `/${encodeURIComponent(name)}`),
  );
  return response.data;
};

export const deleteFragment = async (
  projectId: string,
  name: string,
): Promise<void> => {
  await api.delete(fragmentsPath(projectId, `/${encodeURIComponent(name)}`));
};
